<div class="main-content">
  <app-header [title]="'HEADER.TITLE_HOME' | translate" />
  <div class="row mt-3">
    <div class="col-12">
      <app-profile [mode]="'full'" [subtitle]="'PROFILE.FINAL_USER_SUBTITLE' | translate" />
    </div>
  </div>
  <app-banner-carousel></app-banner-carousel>
  @if (alerts$ | async) {
    <div class="row mt-5">
      <div class="col-12">
        <app-icam-container
          [iconName]="'bell'"
          [iconColor]="'white'"
          fixedTheme="dark"
          [isExpandable]="true"
          (toggleShow)="isOpen = !isOpen"
        >
          <div [ngClass]="{ 'd-flex d-md-block flex-nowrap overflow-auto scrollable': isOpen }">
            @if (!isOpen) {
              <app-icam-machine-alert-warning-recap
                [machines]="machinesBroken$ | async"
                [contracts]="contractsLapsed$ | async"
              />
            }
            @if (isOpen) {
              @for (machineBroken of machinesBroken$ | async; track machineBroken.id) {
                <app-icam-machine-alert [machine]="machineBroken" />
              }
              @for (contractLapsed of contractsLapsed$ | async; track contractLapsed.id) {
                <app-icam-machine-warranty-warning [contract]="contractLapsed" />
              }
            }
          </div>
        </app-icam-container>
      </div>
    </div>
  }
  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container [iconName]="'list'" [iconColor]="'white'" class="my-5">
        <app-table
          [allValues$]="machines$"
          [type]="'machines'"
          [hasChart]="false"
          (selectedFilter)="onSelectedFilter($event)"
          [filters$]="machineFilters$"
          [prevPage]="(prevPage$ | async) ?? undefined"
          [currentPage]="(currentPage$ | async) ?? undefined"
          [nextPage]="(nextPage$ | async) ?? undefined"
          (selectedPage)="onChangePage($event)"
          [totalPages]="(totalPages$ | async) ?? undefined"
          [useInlineKeywordFilter]="true"
        />
      </app-icam-container>
    </div>
  </div>
  <div class="mt-5 pb-3">&copy; {{ getYear() }} ICAM S.P.A - All rights reserved</div>
</div>
